import React, { useState } from "react";
import "./loading.scss";

const Loading = () => {
  const [isIn, setIsIn] = useState(false);

  setTimeout(() => {
    setIsIn(true);
  }, 100);

  return (
    <div className={`loading ${isIn ? "loading--in" : ""}`}>
      <div className="loading__giff" />
    </div>
  );
};

export default Loading;
